import React from "react";
import classes from "./AuthLeftPanel.module.css";
import { isMobile } from "../../Constants";

const AuthLeftPanel = () => {

  return (
    <div className={`col-md-6 ${classes["first-column"]} p-0`}>
      <div className={classes["left-content-wrapper"]}>
        <div className={classes["top-label"]}>
          <p>India's First National Freight Benchmark for <span style={{ color: '#54AF3A', fontSize: "19px" }}>Contracted</span> Freight</p>
        </div>
        <h1 className={classes["main-heading"]}>
          Benchmark your Freight<br />
          <span className={classes["font-regular"]}>Right</span> Cost<br />
          <span className={classes["font-regular"]}>Right</span> Transporter<br />
          <span className={classes["font-regular"]}>Right</span> value.
        </h1>
        <div className={classes["glass-cards-grid"]}>
          <div className={classes["glass-card"]}>
            <div className={classes["card-icon-box"]}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-indian-rupee"><path d="M6 3h12" /><path d="M6 8h12" /><path d="m6 13 8.5 8" /><path d="M6 13h3c6.667 0 6.667-10 0-10" /></svg>
            </div>
            <div className={classes["card-number-wrapper"]}>
              <span className={classes["card-number"]}>₹200</span>
              <span className={classes["card-plus-green"]}>+Cr</span>
            </div>
            <div className={classes["card-label"]}>Saved by customers</div>
          </div>

          <div className={classes["glass-card"]}>
            <div className={classes["card-icon-box"]}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-disc"><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="2" /></svg>
            </div>
            <div className={classes["card-number-wrapper"]}>
              <span className={classes["card-number"]}>750</span>
              <span className={classes["card-plus-green"]}>+</span>
            </div>
            <div className={classes["card-label"]}>Districts covered</div>
          </div>

          <div className={classes["glass-card"]}>
            <div className={classes["card-icon-box"]}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-truck"><path d="M10 17h4V5H2v12h3" /><path d="M20 17h2v-3.34a4 4 0 0 0-1.17-2.83L19 9h-5" /><path d="M14 17h1" /><circle cx="7.5" cy="17.5" r="2.5" /><circle cx="17.5" cy="17.5" r="2.5" /></svg>
            </div>
            <div className={classes["card-number-wrapper"]}>
              <span className={classes["card-number"]}>2300</span>
              <span className={classes["card-plus-green"]}>+</span>
            </div>
            <div className={classes["card-label"]}>Transporter partners</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLeftPanel;
